import React, { useState, useRef, useEffect } from 'react';
import './Statics/Scss/Styles.scss';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Routes from './Routes/Routes';
import Layout from './Components/Common/Organism/Layout';
import { CookieContext } from './Contexts/CookieContext';
import Hotjar from './Handlers/Hotjar';
import './Helpers/Datadog';
import NotFoundLayout from './Components/Common/Organism/NotFoundLayout';
import PrivateRoute from './Components/Features/PrivateRoute';

import Home from './Pages/Home';
import Header from './Components/Common/Organism/Header';
import Footer from './Components/Common/Organism/Footer';
import EmbedHide from './Components/Common/Organism/EmbedHide';

import Logout from './Handlers/_Logout';
import getProductoPremium from './Models/ProductoPremium';
import Cookies from 'js-cookie';
import { DrawerAccountContent } from './Components/Common/Organism/DrawerAccount/DrawerAccountContent';
import { userConSuscripcion, userSinSuscripcion } from './Helpers/HeaderUserProps';
import Modal from './Components/Common/Organism/Modal';
import ModalWizard from './Pages/ModalWizard';

const LaNacion = process.env.REACT_APP_LNREDIRECT;

const App = () => {
    if (!window.dataLayer) window.dataLayer = [];

    if (!window.hj) Hotjar.HotjarRun();
    const [updateCookie, setUpdateCookie] = useState(false);

    const [menuVisibility, setMenuVisibility] = useState(false);
    const el = useRef(null);
    const [showModalSteps, setShowModalSteps] = useState(false);
    const [userSuscriptionProps, setUserSuscriptionProps] = useState(userSinSuscripcion);
    const [userIniciales, setUserIniciales] = useState('');
    const usuarioEmail = Cookies.get('usuarioemail');
    const usuarioNombre = Cookies.get('usuario_detalle_nombre');
    const usuarioApellido = Cookies.get('usuario_detalle_apellido');
    const [visibleSubscriberAttentions, setVisibleSubscriberAttentions] = useState(false);
    const toggleVisible = () => setVisibleSubscriberAttentions(!visibleSubscriberAttentions);

    const handleCloseModal = () => {
        setShowModalSteps(false);
    };

    const closeMenu = () => {
        setTimeout(() => setMenuVisibility(!menuVisibility), 700);
        document.body.classList.remove('menu-open');
    };

    const openMenu = () => {
        setMenuVisibility(!menuVisibility);
        document.body.classList.add('menu-open');
    };

    const handleMenuVisibilityChange = () => {
        if (menuVisibility) closeMenu();
        else openMenu();
    };

    const addBackDrop = (e) => {
        if (menuVisibility && el && !el.current.contains(e.target)) closeMenu();
    };

    useEffect(() => {
        if (getProductoPremium(Cookies.get('ProductoPremiumId'))) {
            setUserSuscriptionProps(userConSuscripcion);
        }
        if (usuarioNombre && usuarioApellido) {
            setUserIniciales((usuarioNombre[0] + usuarioApellido[0]).toUpperCase());
        } else {
            if (usuarioEmail) {
                setUserIniciales(usuarioEmail.slice(0, 2).toUpperCase());
            }
        }
        window.addEventListener('click', addBackDrop);
        return () => {
            window.removeEventListener('click', addBackDrop);
        };
    }, []);

    const handleLogout = () => {
        Logout.Logout(true);
    };

    const hideDrawerMenu = location.pathname !== '/';
    const showHome = !hideDrawerMenu;

    return (
        /*Para el seteo de cookies sin tener que pasar por todos los componentes. Usar hook useContext()*/
        <>
            <CookieContext.Provider value={[updateCookie, setUpdateCookie]}>
                <Router>
                    {showHome ? (
                        <>
                            <EmbedHide>
                                <Header
                                setMenuVisibility={handleMenuVisibilityChange}
                                userSuscriptionProps={userSuscriptionProps}
                                setVisibleSubscriberAttentions={setVisibleSubscriberAttentions}
                                userIniciales={userIniciales}
                                />
                            </EmbedHide>
                            <div className="container">
                                <Home />
                                <DrawerAccountContent
                                    handleLogout={handleLogout}
                                    setShowModalSteps={setShowModalSteps}
                                    userSuscriptionProps={userSuscriptionProps}
                                    visibleSubscriberAttentions={visibleSubscriberAttentions}
                                    toggleVisible={toggleVisible}
                                    userIniciales={userIniciales}
                                />
                            </div>
                            <EmbedHide>
                                <Footer />
                            </EmbedHide>
                            {showModalSteps && (
                                <Modal closeModal={handleCloseModal} classes="--none">
                                    <ModalWizard close={handleCloseModal} />
                                </Modal>
                            )}
                        </>
                    ) : (
                        <Layout>
                            <Switch>
                                {Routes.map((route, i) => (
                                    <PrivateRoute path={route.path} key={i} exact={true} component={route.component} />
                                ))}
                                <Route component={NotFoundLayout} />
                            </Switch>
                        </Layout>
                    )}
                </Router>
            </CookieContext.Provider>
        </>
    );
};

export default App;
